import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-flow: column nowrap;
`;

export const ListRow = styled.div`
    padding: 16px 20px;
    background: #f7f9fb;
    margin: 10px 0;

    &:first-of-type {
        margin-top: 0;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const RowElement = styled.div`
    margin-bottom: 10px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const FlexRowElement = styled(RowElement)`
    display: flex;
    justify-content: space-between;
`;

export const Text = styled.div<{isGray?: boolean}>`
    color: ${(p) => (p.isGray ? colors.textSecondary : colors.textPrimary)};
    font-size: 14px;
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
`;

export const CreateButton = styled(Button)`
    width: auto;
    color: ${colors.white};

    > span {
        padding: 0 16px;
    }
`;

export const HeaderControls = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;
